module.exports = __webpack_public_path__ + "static/ruby-514befa7a168a76156a2dd5a043d73fd.svg";